import { render } from "./delete_button.vue?vue&type=template&id=2a7e75e6&scoped=true&lang=pug"
import script from "./delete_button.vue?vue&type=script&lang=js"
export * from "./delete_button.vue?vue&type=script&lang=js"

import "./delete_button.vue?vue&type=style&index=0&id=2a7e75e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7e75e6"]])

export default __exports__